import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-icon-account-add',
    templateUrl: './icon-account-add.component.html',
    styleUrls: ['./icon-account-add.component.scss']
})
export class IconAccountAddComponent implements OnInit {

    @Input() cssClass = '';

    constructor() { }

    ngOnInit() {
    }

}
